import { ENVIRONMENT } from "@repo/shared";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import * as MathJax from "better-react-mathjax";
import { I18nextProvider } from "react-i18next";

import { queryClient } from "~/api/queryClient";
import { config } from "~/config/mathJaxConfig";
import { CurrentUserStoreProvider } from "~/context/CurrentUserContext";
import { SubscriptionActivationProvider } from "~/context/SubscriptionActivationContext";
import { WebSocketProvider } from "~/providers/WebSocketProvider";

import i18n from "../../../i18n";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <SubscriptionActivationProvider>
          <CurrentUserStoreProvider>
            <WebSocketProvider>
              <MathJax.MathJaxContext config={config}>
                {children}
                {import.meta.env.DEV && import.meta.env.VITE_ENVIRONMENT !== ENVIRONMENT.TEST && (
                  <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
                )}
              </MathJax.MathJaxContext>
            </WebSocketProvider>
          </CurrentUserStoreProvider>
        </SubscriptionActivationProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
}
